export const INITIAL_REMAN_DATA = 2;
export const REMAN_TYPE = 'Reman';
export const SHOPPING_CART_ICON_WIDTH = 16;
export const SHOPPING_CART_ICON_HEIGHT = 15;
export const CURRENCY_TYPE = 'USD';
export const CONTACT_DEALER = 'Contact Dealer';
